(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-box-terms-bar"] && !Shopify.designMode) return;
  try {
    
  class MysteryBoxTermsBar extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector('[data-terms-open]');
      this.dialog = this.querySelector('[data-terms-dialog]');
      this.closeButton = this.querySelector('[data-terms-close]');

      if (!this.openButton || !this.dialog) return;

      this.openHandler = this.open.bind(this);
      this.closeHandler = this.close.bind(this);
      this.backdropHandler = this.handleBackdropClick.bind(this);
      this.cancelHandler = this.handleCancel.bind(this);

      this.openButton.addEventListener('click', this.openHandler);
      this.dialog.addEventListener('click', this.backdropHandler);
      this.dialog.addEventListener('cancel', this.cancelHandler);

      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.closeHandler);
      }
    }

    disconnectedCallback() {
      if (this.openButton) {
        this.openButton.removeEventListener('click', this.openHandler);
      }

      if (this.dialog) {
        this.dialog.removeEventListener('click', this.backdropHandler);
        this.dialog.removeEventListener('cancel', this.cancelHandler);
      }

      if (this.closeButton) {
        this.closeButton.removeEventListener('click', this.closeHandler);
      }
    }

    withTransition(callback) {
      if (document.startViewTransition) {
        document.startViewTransition(callback);
        return;
      }

      callback();
    }

    open() {
      if (!this.dialog || this.dialog.open) return;

      this.withTransition(() => {
        if (this.dialog.showModal) {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }

        requestAnimationFrame(() => {
          this.dialog.classList.add('is-open');
        });
      });
    }

    close() {
      if (!this.dialog || !this.dialog.open) return;

      this.withTransition(() => {
        this.dialog.classList.remove('is-open');
        window.setTimeout(() => {
          if (this.dialog.open) {
            this.dialog.close();
          }
        }, 180);
      });
    }

    handleBackdropClick(event) {
      if (event.target === this.dialog) {
        this.close();
      }
    }

    handleCancel(event) {
      event.preventDefault();
      this.close();
    }
  }

  if (!customElements.get('mystery-box-terms-bar')) {
    customElements.define('mystery-box-terms-bar', MysteryBoxTermsBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-member-photo-wall"] && !Shopify.designMode) return;
  try {
    
  class YGMemberPhotoWallElement extends HTMLElement {
    constructor() {
      super();
      // bound callbacks so they can be added/removed reliably
      this._intersectionCallback = this._intersectionCallback.bind(this);
      this._onResize = this._onResize.bind(this);
      this._observer = null;
    }

    connectedCallback() {
      // Initialize observer when element is attached (only active on small screens)
      this._initObserver();
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      // Cleanup when element is removed
      this._disconnectObserver();
      window.removeEventListener('resize', this._onResize);
    }

    // Create IntersectionObserver and start observing this element
    _initObserver() {
      // Only initialize on small screens
      if (window.innerWidth >= 700) {
        // ensure active class is removed when not in small-screen mode
        this._removeActive();
        return;
      }

      if (this._observer) return;
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(this._intersectionCallback, {
          root: null,
          rootMargin: '0px',
          threshold: [0, 0.75, 1]
        });
        this._observer.observe(this);
      } else {
        // Fallback: immediately mark active for small screens
        this._addActive();
      }
    }

    // Disconnect and cleanup observer
    _disconnectObserver() {
      if (!this._observer) return;
      try {
        this._observer.unobserve(this);
        this._observer.disconnect();
      } catch (err) {
        // ignore cleanup errors
      }
      this._observer = null;
    }

    // Handle window resize: enable/disable observer when crossing 700px breakpoint
    _onResize() {
      const isSmall = window.innerWidth < 700;
      const hasObserver = !!this._observer;
      if (isSmall && !hasObserver) {
        this._initObserver();
      } else if (!isSmall && hasObserver) {
        this._disconnectObserver();
        this._removeActive();
      }
    }

    // IntersectionObserver callback - separated for testability
    _intersectionCallback(entries) {
      for (const entry of entries) {
        if (entry.target !== this) continue;
        const ratio = entry.intersectionRatio || 0;
        if (entry.isIntersecting && ratio >= 0.75) {
          this._addActive();
        } else {
          this._removeActive();
        }
      }
    }

    // Add active class if not present
    _addActive() {
      if (!this.classList.contains('active')) {
        this.classList.add('active');
      }
    }

    // Remove active class if present
    _removeActive() {
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      }
    }
  }

  if (!window.customElements.get('yg-member-photo-wall')) {
    window.customElements.define('yg-member-photo-wall', YGMemberPhotoWallElement);
  }

  } catch(e) { console.error(e); }
})();
})();
